import { render, staticRenderFns } from "./listVulnInfo.vue?vue&type=template&id=042a8305&scoped=true&"
import script from "./listVulnInfo.vue?vue&type=script&lang=ts&"
export * from "./listVulnInfo.vue?vue&type=script&lang=ts&"
import style0 from "./listVulnInfo.vue?vue&type=style&index=0&id=042a8305&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042a8305",
  null
  
)

export default component.exports